























import { Component, Vue } from "vue-property-decorator";
import { championPick } from "@/store/index";
import { Champion, costColor } from "@/models/champion";
import { ActiveSynergy } from "@/models/type";
import router from "@/router";

@Component({
  name: "footer-open",
  components: {
    "pick-counter": () =>
      import("@/components/Organisms/ChampionPickCounter.vue"),
    "champion-deck": () => import("@/components/Molecules/ChampionDeck.vue")
  }
})
export default class ChampionFooterOpen extends Vue {
  costColor: Map<number, string> = costColor;

  get championPicked(): Champion[] {
    return championPick.championPicked;
  }

  get maxCount(): number {
    return championPick.maxCountPickChampion;
  }

  get activeOriginSynergy(): ActiveSynergy[] {
    return championPick.activeOriginSynergy.filter(x => x.isActive);
  }

  get activeClassSynergy(): ActiveSynergy[] {
    return championPick.activeClassSynergy.filter(x => x.isActive);
  }

  removeChampion(targetChampion: Champion) {
    championPick.removeChampionPicked(targetChampion);
  }
}
